export const safeNumber = (
  value: number | undefined,
  toFixedDigit: number,
): number | undefined => {
  return value !== undefined ? Number(value.toFixed(toFixedDigit)) : undefined;
};
